// Instant-paint data cache (SWR-style): pages render last-known data
// immediately from localStorage, then refresh silently in the background.
// Keys are scoped by business id so accounts never see each other's data.
const PREFIX = 'akfy_ic:';
const MAX_AGE_MS = 7 * 24 * 60 * 60 * 1000;
const MAX_ENTRY_BYTES = 2500000;

function scope() {
  try {
    const biz = JSON.parse(localStorage.getItem('akountfly_business') || 'null');
    return biz?.id || 'anon';
  } catch {
    return 'anon';
  }
}

export function readInstant(key) {
  try {
    const raw = localStorage.getItem(`${PREFIX}${scope()}:${key}`);
    if (!raw) return null;
    const { data, t } = JSON.parse(raw);
    if (!t || Date.now() - t > MAX_AGE_MS) return null;
    return data;
  } catch {
    return null;
  }
}

export function writeInstant(key, data) {
  try {
    const raw = JSON.stringify({ data, t: Date.now() });
    if (raw.length > MAX_ENTRY_BYTES) return;
    localStorage.setItem(`${PREFIX}${scope()}:${key}`, raw);
  } catch {
    try {
      clearInstantCache();
      localStorage.setItem(`${PREFIX}${scope()}:${key}`, JSON.stringify({ data, t: Date.now() }));
    } catch { /* quota - give up silently */ }
  }
}

export function clearInstantCache() {
  try {
    Object.keys(localStorage)
      .filter((k) => k.startsWith(PREFIX))
      .forEach((k) => localStorage.removeItem(k));
  } catch { /* noop */ }
}
